import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import About from "@/components/landing/About";
import Services from "@/components/landing/Services";
import Locations from "@/components/landing/Locations";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import { setLenis, scrollToId } from "@/lib/scroll";

const Landing = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    setLenis(lenis);
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    if (window.location.hash) {
      const hash = window.location.hash;
      setTimeout(() => scrollToId(hash), 350);
    }
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <div className="bg-ivory" data-testid="landing-page">
      <Navbar />
      <Hero />
      <Marquee />
      <About />
      <Services />
      <Locations />
      <Contact />
      <Footer />
    </div>
  );
};

export default Landing;
